import { http } from ".";

const SKETCH_TO_IMAGE_PRESET_ID =
  process.env.NODE_ENV === "production" ? 24 : 10;

interface KontextResponse {
  id: string;
  created_at: string;
  image: string; // base64 encoded image
}

export async function requestKontextImage(params: {
  image: File;
  prompt?: string;
  sketch_to_image?: boolean;
  preset?: number;
  user?: string;
}) {
  const { image, prompt, sketch_to_image = false, preset, user } = params;
  const formData = new FormData();
  formData.append("image", image);
  if (prompt != null) formData.append("prompt", prompt);
  
  const finalPreset = sketch_to_image ? SKETCH_TO_IMAGE_PRESET_ID : preset;
  if (finalPreset != null) formData.append("preset", finalPreset.toString());
  
  if (user != null) formData.append("user", user);

  return http.post<KontextResponse[]>("/image/kontext/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 360000, // 6 minutes
  });
} 